import { IM_USER_INFO } from '@/typings/global';
import { ActionModify, BASE_CONFIG, BASE_CONFIG_CONTACT, IndexState } from '@/typings/reducer';

export enum INDEX_TYPE {
    // 设置用户基本信息
    SET_USER_INFO = 'SET_USER_INFO',
    // 重制用户数据
    SET_DEFAULT_USER_STATE = 'SET_DEFAULT_USER_STATE',
    // loading状态
    SET_LOADING_STATUS = 'SET_LOADING_STATUS',
    // 基础配置注入
    SET_BASE_CONFIG = 'SET_BASE_CONFIG',
    // 设置工单未读提示
    SET_FORM_TIP = 'SET_FORM_TIP',
    // 设置屏幕方向
    SET_ORIENTATION = 'SET_ORIENTATION',
    // 当前查看的 Dify 工作流日志
    SET_DIFY_LOG_WORKFLOW_RUN_ID = 'SET_DIFY_LOG_WORKFLOW_RUN_ID',
    // 设置联系方式
    SET_CONTACT = 'SET_CONTACT'
}

export interface IndexSetUserInfoAction {
    type: INDEX_TYPE.SET_USER_INFO;
    payload: IM_USER_INFO;
}
export interface IndexSetDefaultUserStateAction {
    type: INDEX_TYPE.SET_DEFAULT_USER_STATE;
    payload: never;
}
export interface IndexSetLoadingAction {
    type: INDEX_TYPE.SET_LOADING_STATUS;
    payload: boolean;
}
export interface IndexSetBaseConfigAction {
    type: INDEX_TYPE.SET_BASE_CONFIG;
    payload: BASE_CONFIG;
}

export interface IndexSetFormTipAction {
    type: INDEX_TYPE.SET_FORM_TIP;
    payload: number;
}
export interface IndexSetOrientationAction {
    type: INDEX_TYPE.SET_ORIENTATION;
    payload: string;
}
export interface IndexSetDifyLogWorkflowRunIdAction {
    type: INDEX_TYPE.SET_DIFY_LOG_WORKFLOW_RUN_ID;
    payload: string;
}
export interface IndexSetContactAction {
    type: INDEX_TYPE.SET_CONTACT;
    payload: BASE_CONFIG_CONTACT;
}

export type IndexModifyAction =
    | ActionModify<IndexSetUserInfoAction, IndexState>
    | ActionModify<IndexSetDefaultUserStateAction, IndexState>
    | ActionModify<IndexSetLoadingAction, IndexState>
    | ActionModify<IndexSetBaseConfigAction, IndexState>
    | ActionModify<IndexSetFormTipAction, IndexState>
    | ActionModify<IndexSetOrientationAction, IndexState>
    | ActionModify<IndexSetDifyLogWorkflowRunIdAction, IndexState>
    | ActionModify<IndexSetContactAction, IndexState>;
export type IndexModifyType = INDEX_TYPE;
